import { render, staticRenderFns } from "./BreadCrumbHeader.vue?vue&type=template&id=4ca55596"
import script from "./BreadCrumbHeader.vue?vue&type=script&lang=js"
export * from "./BreadCrumbHeader.vue?vue&type=script&lang=js"
import style0 from "./BreadCrumbHeader.vue?vue&type=style&index=0&id=4ca55596&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports